import { Shield, Phone, Globe, MapPin, Bell, LogOut, ChevronRight } from "lucide-react";
import { useCustomer } from "../lib/auth";

export default function Profile() {
  const { user, ready, logout, setAuthOpen } = useCustomer();

  if (ready && !user) {
    return (
      <div className="mx-auto max-w-3xl px-4 pt-8 text-center" data-testid="cust-profile">
        <h1 className="font-heading text-2xl text-[#2A211C]">Your account</h1>
        <p className="mt-2 text-sm text-[#7A6E64]">Sign in to manage bookings, payments and preferences.</p>
        <button onClick={() => setAuthOpen(true)} data-testid="cust-profile-signin" className="mt-4 rounded-xl bg-[#8B1A2B] px-6 py-2.5 text-sm font-semibold text-white">Sign in</button>
      </div>
    );
  }

  const rows = [
    { icon: Phone, label: "Mobile number", value: user?.phone || "Add number" },
    { icon: Globe, label: "Language", value: "English" },
    { icon: MapPin, label: "Service location", value: "Rajajinagar, Bengaluru" },
    { icon: Bell, label: "Notifications", value: "On" },
  ];

  return (
    <div className="mx-auto max-w-3xl px-4 pt-5 pc-fade-in" data-testid="cust-profile">
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#8B1A2B]">Your account</p>
      <h1 className="mt-1 font-heading text-2xl text-[#2A211C]">Profile</h1>

      <div className="mt-4 flex items-center gap-3 rounded-2xl border border-[#EBE0D0] bg-white p-4">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#8B1A2B] font-heading text-xl text-white">{(user?.name || user?.email || "U")[0].toUpperCase()}</span>
        <div>
          <p className="font-heading text-lg text-[#2A211C]">{user?.name || "PurohithConnect member"}</p>
          <p className="text-xs text-[#7A6E64]">{user?.email}</p>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-3 gap-3">
        {[["3", "Bookings"], ["2", "Reviews"], ["100%", "Protected"]].map(([n, l]) => (
          <div key={l} className="rounded-2xl border border-[#EBE0D0] bg-white p-3 text-center">
            <p className="font-heading text-xl text-[#8B1A2B]">{n}</p>
            <p className="text-[11px] text-[#7A6E64]">{l}</p>
          </div>
        ))}
      </div>

      <div className="mt-3 flex items-center gap-3 rounded-2xl bg-[#F5E9DA] p-4">
        <Shield size={20} className="text-[#8B1A2B]" />
        <p className="text-sm text-[#5C5149]">Your bookings are protected — verified purohits, secure sessions, support for every ceremony.</p>
      </div>

      <h2 className="mt-5 font-heading text-base text-[#2A211C]">Account settings</h2>
      <div className="mt-2 overflow-hidden rounded-2xl border border-[#EBE0D0] bg-white">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center justify-between border-b border-[#F0E7D9] px-4 py-3 last:border-0">
            <span className="flex items-center gap-2.5 text-sm text-[#2A211C]"><r.icon size={16} className="text-[#8B1A2B]" /> {r.label}</span>
            <span className="flex items-center gap-1 text-xs text-[#7A6E64]">{r.value} <ChevronRight size={14} className="text-[#C9BBA8]" /></span>
          </div>
        ))}
      </div>

      <button onClick={logout} data-testid="cust-logout" className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl border border-[#E7C9CD] py-3 text-sm font-semibold text-[#8B1A2B]">
        <LogOut size={16} /> Log out
      </button>
    </div>
  );
}
